<div class="container_map">
  <div id="map" class="map"></div>
</div>
